import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {
    NotificacionWebCount,
    NotificacionWebNovedades,
    NotificacionWebOpenResult,
    NotificacionWebPage,
    TipoNotificacionWeb,
    TipoNotificacionWebOption
} from '@app/domain/notificacion-web';

@Injectable({
    providedIn: 'root'
})
export class NotificacionWebService {

    private readonly baseUrl = environment.endpointApi;
    private readonly hiddenLoaderHeaders = {hideLoader: 'S'};

    constructor(private http: HttpClient) {
    }

    findAll(pageNumber = 0,
            perPage = 10,
            tipo?: TipoNotificacionWeb): Observable<NotificacionWebPage> {
        let params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('perPage', perPage.toString());
        if (tipo) {
            params = params.set('tipo', tipo);
        }
        return this.http.get<NotificacionWebPage>(`${this.baseUrl}/notificaciones`, {
            params,
            headers: this.hiddenLoaderHeaders
        });
    }

    findHistory(pageNumber = 0,
                perPage = 10,
                tipo?: TipoNotificacionWeb,
                fechaDesde?: Date,
                fechaHasta?: Date,
                soloNoAtendidas = false): Observable<NotificacionWebPage> {
        let params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('perPage', perPage.toString());
        if (tipo) {
            params = params.set('tipo', tipo);
        }
        if (fechaDesde && fechaHasta) {
            params = params.set('fechaDesde', this.formatDate(fechaDesde));
            params = params.set('fechaHasta', this.formatDate(fechaHasta));
        }
        if (soloNoAtendidas) {
            params = params.set('soloNoAtendidas', 'true');
        }
        return this.http.get<NotificacionWebPage>(`${this.baseUrl}/notificaciones/historial`, {
            params,
            headers: this.hiddenLoaderHeaders
        });
    }

    countUnopened(tipos: TipoNotificacionWeb[] = []): Observable<NotificacionWebCount> {
        let params = new HttpParams();
        tipos.forEach(tipo => params = params.append('tipos', tipo));
        return this.http.get<NotificacionWebCount>(`${this.baseUrl}/notificaciones/sin-abrir/count`, {
            params,
            headers: this.hiddenLoaderHeaders
        });
    }

    countNovedades(): Observable<NotificacionWebNovedades> {
        return this.http.get<NotificacionWebNovedades>(`${this.baseUrl}/notificaciones/novedades/count`, {
            headers: this.hiddenLoaderHeaders
        });
    }

    marcarVistas(): Observable<void> {
        return this.http.patch<void>(`${this.baseUrl}/notificaciones/vistas`, null, {
            headers: this.hiddenLoaderHeaders
        });
    }

    limpiarRecientes(): Observable<void> {
        return this.http.patch<void>(`${this.baseUrl}/notificaciones/limpiadas`, null, {
            headers: this.hiddenLoaderHeaders
        });
    }

    findTypes(): Observable<TipoNotificacionWebOption[]> {
        return this.http.get<TipoNotificacionWebOption[]>(`${this.baseUrl}/notificaciones/tipos`);
    }

    markAsOpened(id: number): Observable<NotificacionWebOpenResult> {
        return this.http.patch<NotificacionWebOpenResult>(`${this.baseUrl}/notificaciones/${id}/abierta`, null, {
            headers: this.hiddenLoaderHeaders
        });
    }

    private formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        return `${day}-${month}-${date.getFullYear()}`;
    }
}
